import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft } from "react-feather";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ImageWithBasePath from "core/img/imagewithbasebath";
import { sampleAttendanceData } from "core/json/sample_data";
import { format, addDays, startOfMonth, endOfMonth } from "date-fns";
import { all_routes } from "Router/all_routes";
import Error404 from "MainPages/ErrorPages/error404";
import { Save } from "react-feather";
import { useCreateMonthlyAttendanceMutation } from "AppQuries/attendance/add-attendance";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import ToastNotification from "Components/UI/ToastNotification";
import { Table } from "antd";
import moment from "moment";
import { importAttendanceValidation } from "core/Operations/ValidationSchema/attendanceValidationSchema";
import { toast } from "core/Operations/toast";
const ImportAttendance = () => {
  const userData = useSelector(loggedInUser);

  const {
    mutate: createMonthlyAttendance,
    isPending,
    isFetching,
    isError: isCreatingAttendaceError,
    error: creatingAttendaceError,
  } = useCreateMonthlyAttendanceMutation();
  const navigate = useNavigate();
  const [employeeAttendanceList, setEmployeeAttendanceList] = useState([]);
  
  const [show, setShow] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [attendanceData, setAttendanceData] = useState(null);
  const [attendanceTableData, setAttendanceTableData] = useState([]);

  // const [columns, setColumns] = useState([]);
  const handleDownloadSample = () => {
    const worksheet = XLSX.utils.aoa_to_sheet(sampleAttendanceData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Monthly_Attendance_Sample.xlsx");
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploadStatus("Processing...");
    setUploadedFileName(file.name);

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        const headers = data[0];
        const body = data.slice(1);
        // const tableColumns = headers.map((header) => ({
        //   title: header,
        //   dataIndex: header,
        //   key: header,
        // }));
        if (
          !headers.includes("EmployeeCode") ||
          !headers.includes("AttendanceYear") ||
          !headers.includes("AttendanceMonth")
        ) {
          throw new Error("Missing required headers in Excel file");
        }
        const companyCode = userData?.companyCode;
        const formattedData = body.map((row) => {
          const employeeCode = Number(row[headers.indexOf("EmployeeCode")]);
          const attendanceYear = Number(row[headers.indexOf("AttendanceYear")]);
          const attendanceMonth = Number(
            row[headers.indexOf("AttendanceMonth")]
          );
          const startDate = new Date(attendanceYear, attendanceMonth - 1, 1); // Adjust month index

          const attendance = [];
          let key = 0;
          for (let i = 2; i < headers.length; i += 3) {
            if (!headers[i]) continue;
            const currentDate = addDays(startOfMonth(startDate), key++);

            if (currentDate <= endOfMonth(startDate)) {
              attendance.push({
                employeeCode: employeeCode,
                attendanceValue: row[i + 1],
                inTime: row[i + 2] || null,
                outTime: row[i + 3] || null,
                attendanceDate: format(currentDate, "yyyy-MM-dd"),
                createUser: userData?.userName,
                createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
                  new Date(),
                  "HH:mm:ss.SSS"
                )}Z`,
                modifyUser: userData?.userName,
                modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
                  new Date(),
                  "HH:mm:ss.SSS"
                )}Z`,
                isCheck: Boolean(row[i + 1]),
                scheduleId: 0,
                projectCode: "",
                remarks: "",
                mode: "MM",
                waitingTime:"00:00:00",
                wtrot:"00:00:00",
                oT1: 0,
                oT2: 0,
                extraCharge: 0,
                isApproved: false,
                wtnhEdit: true,
                supplierCompany: "",
                service: "",
                isReviewed: false,
                reviewDate: "",
                reviewBy: "",
                approvedDate: "",
                approvedBy: "",
                haveSplit: false,
              });
            }
          }

          return { companyCode, attendanceYear, attendanceMonth, attendance };
        });
        // importAttendanceValidation
        //   .validate(formattedData)
        //   .then(() => {
        // setColumns(tableColumns);
        setAttendanceData(formattedData[0]);
        // setAttendanceTableData(
        //   formattedData[0]?.attendance.reduce((acc, item) => {
        //     const { employeeCode } = item;
        //     if (!acc[employeeCode]) {
        //       acc[employeeCode] = [];
        //     }
        //     acc[employeeCode].push(item);
        //     return acc;
        //   }, {})
        // );
        setUploadStatus("File processed successfully!");
        // })
        // .catch((err) => {
        //   console.error("Validation error:", err);
        //   setUploadStatus("Validation error: " + err.message);
        // });
      } catch (error) {
        console.error("Processing error:", error);
        setUploadStatus("Processing error: " + error.message);
      }
    };

    reader.readAsBinaryString(file);
  };
  const handleRemoveFile = () => {
    setUploadedFileName("");
    setAttendanceData(null);
    setUploadStatus("");
  };

  const submitAttendance = () => {
    createMonthlyAttendance(attendanceData, {
      onSuccess: (response) => {
        
        const isSuccessful = response[0]?.response;
        toast.success(
          isSuccessful
            ? "Attendance Saved Successfully."
            : response[0]?.errorMessage || "Error in saving attendance."
        );
        
        if (isSuccessful) {
          setShow(false);
          setTimeout(() => {
            navigate(`${all_routes.attendance}${all_routes.attendance_filter}`);
          }, 1000);
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
        
      },
    });
  };

  // const fixedColumns = [
  //   {
  //     title: "Emp Code",
  //     dataIndex: "employeeCode",
  //     key: "employeeCode",
  //   },
  //   // {
  //   //   title: "Emp Name",
  //   //   dataIndex: "fullName",
  //   //   key: "fullName",
  //   //   fixed: "left",
  //   //   width: 200,
  //   // },
  // ];

  // const getDynamicColumns = (attendanceDetails) => {
  
  //   return Array.isArray(attendanceDetails)
  //     ? attendanceDetails.map((detail) => {
  //         const date = moment(detail.attendaceDate).format("YYYY-MM-DD");
  //         const day = moment(detail.attendaceDate).format("dddd");

  //         return {
  //           title: (
  //             <div>
  //               <div>{date}</div>
  //               <div style={{ fontSize: "12px", color: "#888" }}>{day}</div>
  //             </div>
  //           ),
  //           children: [
  //             {
  //               title: "In Time",
  //               key: `${date}_inTime`,
  //               dataIndex: "inTime",
  //               // render: () =>
  //               //   `${detail.inTime.value.hours}:${detail.inTime.value.minutes
  //               //     .toString()
  //               //     .padStart(2, "0")} AM`,
  //               render: () =>
  //                 detail.inTime === "00:00:00"
  //                   ? " - "
  //                   : moment(detail.inTime, ["HH:mm"]).format("hh:mm A"),
  //             },
  //             {
  //               title: "Out Time",
  //               key: `${date}_outTime`,
  //               dataIndex: "outTime",
  //               // render: () =>
  //               //   `${
  //               //     detail.outTime.value.hours > 12
  //               //       ? detail.outTime.value.hours - 12
  //               //       : detail.outTime.value.hours
  //               //   }:${detail.outTime.value.minutes
  //               //     .toString()
  //               //     .padStart(2, "0")} ${
  //               //     detail.outTime.value.hours >= 12 ? "PM" : "AM"
  //               //   }`,
  //               render: () =>
  //                 detail.outTime === "00:00:00"
  //                   ? " - "
  //                   : moment(detail.outTime, ["HH:mm"]).format("hh:mm A"),
  //             },
  //           ],
  //         };
  //       })
  //     : [];
  // };

  // const dynamicColumns = getDynamicColumns(attendanceData?.attendance);
  // const columns = [...fixedColumns, ...dynamicColumns];


  // if (isPending) return <LoadingSpinner />;
  if (isCreatingAttendaceError)
    return <Error404 error={creatingAttendaceError} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Import Attendance</h4>
                <h6>Add attendance date from excel</h6>
              </div>
            </div>
            {attendanceData && (
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="add-new-tooltip">Save</Tooltip>}
                >
                  <button
                    type="button"
                    className="btn btn-added"
                    onClick={submitAttendance}
                    disabled={isPending}
                  >
                    {isPending ? (
                      <>
                        <i className="fas fa-spinner fa-spin me-2" /> Loading...
                      </>
                    ) : (
                      <>
                        <Save className="me-2" />
                        Save
                      </>
                    )}
                  </button>
                </OverlayTrigger>
              </div>
            )}
            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
              >
                <Link
                  to={`${all_routes.attendance}${all_routes.attendance_filter}`}
                  className="btn btn-added btn-secondary"
                  disabled={isPending}
                >
                  <ArrowLeft className="me-2" />
                  Back
                </Link>
              </OverlayTrigger>
            </div>
          </div>
          <div className="card border-0">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12">
                  <div className="modal-footer-btn download-file mb-3">
                    <button
                      onClick={handleDownloadSample}
                      className="btn btn-submit"
                    >
                      Download Sample File
                    </button>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="input-blocks image-upload-down mb-10">
                    <label> Upload Excel File</label>
                    <div className="image-upload download">
                      {!uploadedFileName ? (
                        <>
                          <input
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileUpload}
                          />
                          <div className="image-uploads">
                            <ImageWithBasePath
                              src="assets/img/download-img.png"
                              alt="img"
                            />
                            <h4>
                              Drag and drop a <span>file to upload</span>
                            </h4>
                          </div>
                        </>
                      ) : (
                        <div className="uploaded-file-info">
                          <div className="image-uploads">
                            <p>Uploaded File: {uploadedFileName}</p>
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={handleRemoveFile}
                            >
                              Remove File
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-12" style={{ marginTop: "75px" }}>
                  {uploadStatus && (
                    <div
                      className={`alert ${
                        uploadStatus.includes("Successfully")
                          ? "alert-success"
                          : "alert-info"
                      } mt-3`}
                    >
                      {uploadStatus}
                    </div>
                  )}
                </div>
                {/* <div className="col-lg-12">
                  <div className="table-responsive">
                    {attendanceData && (
                      <Table
                        columns={columns}
                        dataSource={attendanceTableData}
                        pagination={false}
                      />
                      // <pre
                      //   className="alert alert-light mt-3"
                      //   style={{ maxHeight: "400px" }}
                      // >
                      //   {JSON.stringify(attendanceData, null, 2)}
                      // </pre>
                    )}
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportAttendance;
